import Link from "next/link";
import React from "react";
import { IoMdHeart } from "react-icons/io";

export default function CompanyMotto() {
  return (
    <div className=" w-full flex gap-1 justify-center items-center">
      Made with
      <IoMdHeart /> by
      <Link href="https://theantopolis.com/" target="_blank">Antopolis</Link>
    </div>
  );
}
